import FormLabel from '@rio-cloud/rio-uikit/FormLabel';
import type React from 'react';
import { useIntl } from 'react-intl';

interface Props {
    id: string;
    required: boolean;
    setValue: (value: string) => void;
    value: string;
    type: string;
    maxLength: number;
    pattern?: string;
}

export const TextInput = ({ id, required, value, setValue, type, maxLength, pattern }: Props) => {
    const intl = useIntl();
    const onChange = (event: React.ChangeEvent<HTMLInputElement>) => setValue(event.target.value);

    return (
        <div className='form-group'>
            <FormLabel htmlFor={id}>
                {intl.formatMessage({ id })}
                {required ? '*' : ''}
            </FormLabel>
            <input
                id={id}
                className='form-control'
                placeholder={intl.formatMessage({ id })}
                type={type}
                required={required}
                value={value}
                onChange={onChange}
                maxLength={maxLength}
                pattern={pattern}
            />
        </div>
    );
};
